// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__240XR","container":"styles_container___CreF","title":"styles_title__bEkv6","wrapper":"styles_wrapper__5NGBj","answer":"styles_answer__olgzF"};